import React, { useContext } from "react";
import { CompareContext } from "../../App";

const parseTags = (tags) => {
  if (Array.isArray(tags)) return tags;
  try {
    return JSON.parse(tags);
  } catch {
    return [];
  }
};

const CourseCard = ({ course: c, onEnroll }) => {
  const { compareList, toggleCompare } = useContext(CompareContext);
  const prov = c.provider || {};
  const tags = parseTags(c.tags);
  const isCompared = compareList?.some((x) => x.id === c.id);

  return (
    <div className="course-card" id={`card-${c.id}`}>
      <div
        className="course-card-header"
        style={{
          background: `linear-gradient(135deg,${prov.bg || "#f0f2f8"},${prov.bg || "#e8eaf8"}dd)`,
          position: "relative",
          overflow: "hidden",
          padding: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {prov.picLogo ? (
          <img
            src={`${process.env.REACT_APP_SERVER_URL}${prov.picLogo}`}
            alt={prov.name}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
            onError={(e) => {
              e.target.style.display = "none";
            }}
          />
        ) : (
          <span style={{ fontSize: 30 }}>{c.emoji}</span>
        )}
        <div
          className={`compare-check${isCompared ? " checked" : ""}`}
          onClick={() => toggleCompare && toggleCompare(c)}
          style={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 5,
            background: "#043d9f",
            color: "#fff",
            border: "none",
            width: 32,
            height: 32,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          }}
        >
          {isCompared ? "✓" : "+"}
        </div>
      </div>

      <div className="course-card-body">
        <div className="provider-row">
          <div
            className="provider-logo"
            style={{ background: prov.bg, color: prov.color }}
          >
            {prov.logo}
          </div>
          <span className="provider-name">{prov.name || c.provId}</span>
        </div>
        <div className="course-title">{c.title}</div>
        <div className="course-meta">
          <div className="meta-item">
            <span className="stars">★</span>
            {c.rating} ({c.students})
          </div>
          <div className="meta-item">⏱ {c.duration}</div>
          <div className="meta-item">📶 {c.level}</div>
          {c.hasCert && <div className="meta-item">🎓 Cert</div>}
          <div className="meta-item">
            {c.classes?.toLowerCase().includes("weekend") ? "🎯" : "📅"}{" "}
            {c.classes}
          </div>
          <div className="meta-item">📝 {c.remarks}</div>
        </div>
        <div className="course-tags">
          {tags.map((t) => (
            <span key={t} className="tag">
              {t}
            </span>
          ))}
          {c.featured && <span className="tag featured">⭐ Featured</span>}
        </div>

        <div className="course-footer">
          <div>
            {/* ONLINE */}
            <div>
              <span style={{ fontSize: 11, color: "var(--text3)" }}>
                Online:
              </span>{" "}
              {c.price === 0 && c.origPrice === 0 ? (
                <span className="price free">Free</span>
              ) : (
                <>
                  {/* Price */}
                  {c.price === 1 ? (
                    <span className="price free">N/A</span>
                  ) : (
                    c.price > 1 && (
                      <span className="price">₹{c.price.toLocaleString()}</span>
                    )
                  )}

                  {/* Original Price */}
                  {c.origPrice === 1 ? (
                    <span className="price-orig">N/A</span>
                  ) : (
                    c.origPrice > 1 && (
                      <span className="price-orig">
                        ₹{c.origPrice.toLocaleString()}
                      </span>
                    )
                  )}
                </>
              )}
            </div>

            {/* OFFLINE */}
            <div style={{ marginTop: 4 }}>
              <span style={{ fontSize: 11, color: "var(--text3)" }}>
                Offline:
              </span>{" "}
              {c.offPrice === 0 && c.offOrigPrice === 0 ? (
                <span className="price free">Free</span>
              ) : (
                <>
                  {/* Offline Price */}
                  {c.offPrice === 1 ? (
                    <span className="price free">N/A</span>
                  ) : (
                    c.offPrice > 1 && (
                      <span className="price">
                        ₹{c.offPrice.toLocaleString()}
                      </span>
                    )
                  )}

                  {/* Offline Original Price */}
                  {c.offOrigPrice === 1 ? (
                    <span className="price-orig">N/A</span>
                  ) : (
                    c.offOrigPrice > 1 && (
                      <span className="price-orig">
                        ₹{c.offOrigPrice.toLocaleString()}
                      </span>
                    )
                  )}
                </>
              )}
            </div>
          </div>

          <button
            className="btn-enroll"
            onClick={() => onEnroll && onEnroll(c)}
          >
            Enroll →
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard;
